import React, { useEffect } from "react";
import {
  Row,
  Col,
  Label,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
} from "reactstrap";
import { Calendar } from "react-feather";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
// import {
//   fetchCustomersList,
//   fetchSuppliersList,
//   fetchVehiclesList,
// } from "../../../slices/thunks";

import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { fetchLedgerReport } from "../../slices/GSTReport/thunk";
import {
  fetchCustomersList,
  fetchSuppliersList,
  fetchVehiclesList,
} from "../../slices/thunks";
import { fetchTaxList } from "../../slices/TaxMaster/thunk";

const validationSchema = Yup.object({
  customerId: Yup.string().required("Customer is required"),
});

const ReportLedger = ({ onCloseForm }) => {
  const dispatch = useDispatch();

  const selector = createSelector(
    (state) => state,
    (state) => ({
      taxes: state.TaxMaster.taxes,
      suppliers: state.Supplier.suppliers,
      customersList: state.Customer.customers,
      vehicles: state.Vehicle.vehicles,
      activeSessions: state.Session.selectedSessionYear,
    })
  );

  const { suppliers, customersList, activeSessions, vehicles } =
    useSelector(selector);

  useEffect(() => {
    dispatch(fetchTaxList({ isPagination: 0 }));
    dispatch(fetchVehiclesList({ isPagination: 0 }));
    dispatch(fetchCustomersList({ isPagination: 0 }));
    dispatch(fetchSuppliersList({ isPagination: 0 }));
  }, [dispatch]);

  const paymentOptions = [
    { value: true, label: "Paid" },
    { value: false, label: "Unpaid" },
  ];

  return (
    <div
      className="page-content d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", background: "#f8f9fa" }}
    >
      <div className="w-100" style={{ maxWidth: "900px" }}>
        <Card className="shadow-sm">
          <CardHeader className="bg-white">
            <h4 className="mb-0 text-start">Ledger Report</h4>
          </CardHeader>

          <CardBody>
            <Formik
              enableReinitialize
              initialValues={{
                customerId: "",
                sessionId: activeSessions?.id || "",
                fromDate: null,
                toDate: null,
                paymentAction: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                const payload = { ...values };

                if (
                  payload.paymentAction === "" ||
                  payload.paymentAction === null
                ) {
                  delete payload.paymentAction;
                }

                if (payload.fromDate === "" || payload.fromDate === null) {
                  delete payload.fromDate;
                }

                if (payload.toDate === "" || payload.toDate === null) {
                  delete payload.toDate;
                }

                dispatch(fetchLedgerReport(payload));
                resetForm();
                onCloseForm && onCloseForm();
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <Row className="g-4">
                    {/* Left Column */}
                    <Col md={6}>
                      {/* SESSION */}
                      <FormGroup>
                        <Label className="form-label">Session</Label>
                        <input
                          type="text"
                          className="form-control bg-light"
                          disabled
                          value={activeSessions?.name || ""}
                        />
                      </FormGroup>

                      {/* CUSTOMER */}

                      {/* FROM DATE */}
                      <FormGroup style={{ position: "relative" }}>
                        <Label className="form-label">From Date</Label>
                        <div style={{ position: "relative" }}>
                          <Flatpickr
                            className="form-control pe-5"
                            value={values.fromDate}
                            onChange={
                              (date) => {
                                const fromDateValue = date?.[0]
                                  ? (() => {
                                      const d0 = date[0];
                                      const y = d0.getFullYear();
                                      const m = String(
                                        d0.getMonth() + 1
                                      ).padStart(2, "0");
                                      const dd = String(d0.getDate()).padStart(
                                        2,
                                        "0"
                                      );
                                      return `${dd}-${m}-${y}`;
                                    })()
                                  : null;
                                setFieldValue("fromDate", fromDateValue);
                              }

                              //   setFieldValue(
                              //     "fromDate",
                              //     date?.[0]?.toISOString().substring(0, 10) ||
                              //       null
                              //   )
                            }
                          />
                          <Calendar
                            size={18}
                            className="text-muted"
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    {/* Right Column */}
                    <Col md={6}>
                      {/* SUPPLIER */}
                      <FormGroup>
                        <Label className="form-label">
                          Customer <span className="text-danger">*</span>
                        </Label>
                        <Select
                          options={customersList.map((c) => ({
                            value: c.id,
                            label: c.name,
                          }))}
                          value={
                            values.customerId
                              ? {
                                  value: values.customerId,
                                  label:
                                    customersList.find(
                                      (c) => c.id === values.customerId
                                    )?.name || "",
                                }
                              : null
                          }
                          onChange={(opt) => {
                            setFieldValue("customerId", opt?.value || "");
                          }}
                          placeholder="Select Customer"
                          classNamePrefix="react-select"
                        />
                        <ErrorMessage
                          name="customerId"
                          component="div"
                          className="text-danger small mt-1"
                        />
                      </FormGroup>
                      {/* TO DATE */}
                      <FormGroup style={{ position: "relative" }}>
                        <Label className="form-label">To Date</Label>
                        <div style={{ position: "relative" }}>
                          <Flatpickr
                            className="form-control pe-5"
                            value={values.toDate}
                            onChange={(date) => {
                              const toDateValue = date?.[0]
                                ? (() => {
                                    const d0 = date[0];
                                    const y = d0.getFullYear();
                                    const m = String(
                                      d0.getMonth() + 1
                                    ).padStart(2, "0");
                                    const dd = String(d0.getDate()).padStart(
                                      2,
                                      "0"
                                    );
                                    return `${dd}-${m}-${y}`;
                                  })()
                                : null;

                              setFieldValue("toDate", toDateValue);
                            }}
                          />
                          <Calendar
                            size={18}
                            className="text-muted"
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-label">Payment</Label>

                        <Select
                          options={paymentOptions}
                          value={
                            paymentOptions.find(
                              (opt) => opt.value === values.paymentAction
                            ) || null
                          }
                          onChange={(opt) =>
                            setFieldValue("paymentAction", opt ? opt.value : "")
                          }
                          placeholder="All Payments"
                          classNamePrefix="react-select"
                          isClearable
                        />
                      </FormGroup>
                    </Col>

                    {/* SUBMIT BUTTON */}
                    <Col xs={12} className="text-center mt-2">
                      <Button color="success" className="px-5" type="submit">
                        Download Report
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ReportLedger;
